<script setup lang="ts"></script>

<template>
    <div class="bg-slate-100 h-[1px]"></div>
</template>

<style></style>
